module.exports = __webpack_public_path__ + "static/media/blue-candy.a58ef5ce.png";